import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _orderBy from 'lodash/orderBy';

import MainLayout from 'components/Layouts/MainLayout';
import { EmptyWithGraphic } from 'components/Empty/EmptyWithGraphic';
import WorkflowTriggerModal from 'components/WorkflowTriggerModal';

import { Card, palette } from '@m12s/component-library';
import { questionCircle } from 'lib/icons';
import useWorkflowTrigger from 'pages/WorkflowTrigger/useWorkflowTrigger';

import {
  Grid,
  ExtendedTitle,
  ExtendedDetail,
  CardText,
  CardContainer,
} from './styled';

const WorkflowGrid = ({ data, machine, t }) => {
  const { submit, loading } = useWorkflowTrigger();
  const [selectedWorkflow, setSelectedWorkflow] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleWorkflowClick = (workflow) => {
    setSelectedWorkflow(workflow);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedWorkflow(null);
  };

  const handleModalSubmit = (workflow, message) => {
    submit(workflow, machine, message);
    handleModalClose();
  };

  return (
    <MainLayout.Container direction="column" bg={palette.Grey100}>
      {data.length > 0 ? (
        <Grid>
          {_orderBy(data, 'name').map((workflow, idx) => {
            const { name, id } = workflow;
            const { description } = workflow.evaluation;

            return (
              <CardContainer
                key={id}
                role="button"
                onClick={() => {
                  handleWorkflowClick(workflow);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    handleWorkflowClick(workflow);
                  }
                }}
                tabIndex={idx}
              >
                <Card
                  type="extended"
                  name={name}
                  color={palette.Grey300}
                  style={{ height: '8rem' }}
                >
                  <CardText>
                    <ExtendedTitle>{name}</ExtendedTitle>
                    {description && (
                      <ExtendedDetail>{description}</ExtendedDetail>
                    )}
                  </CardText>
                </Card>
              </CardContainer>
            );
          })}
        </Grid>
      ) : (
        <EmptyWithGraphic
          icon={questionCircle}
          text={t('No Workflows Found')}
          subtext={t('noWorkflowsDesc')}
        />
      )}

      <WorkflowTriggerModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        onSubmit={handleModalSubmit}
        workflow={selectedWorkflow}
        loading={loading}
      />
    </MainLayout.Container>
  );
};

WorkflowGrid.propTypes = {
  data: PropTypes.array,
  machine: PropTypes.object,
  t: PropTypes.func,
};

export default WorkflowGrid;
